var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "url(#paint0_radial_50_126)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_126)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_50_126)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_50_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 15.627C17.52 15.9603 17.1311 16.4086 16.869 16.9309C16.6068 17.4532 16.4797 18.0328 16.4991 18.6169C16.5186 19.2009 16.6841 19.7708 16.9806 20.2744C17.277 20.7781 17.6948 21.1994 18.196 21.5M30 15.627C30.4634 15.9492 30.8418 16.3789 31.103 16.8792C31.3643 17.3795 31.5005 17.9356 31.5 18.5C31.5 19.689 30.907 20.74 30 21.372M34 33V32.4C34 30.16 34 29.04 33.564 28.184C33.1807 27.431 32.5688 26.8187 31.816 26.435M14 33V32.4C14 30.16 14 29.04 14.436 28.184C14.8193 27.431 15.4312 26.8187 16.184 26.435M24 22C24.4596 22 24.9148 21.9095 25.3394 21.7336C25.764 21.5577 26.1499 21.2999 26.4749 20.9749C26.7999 20.6499 27.0577 20.264 27.2336 19.8394C27.4095 19.4148 27.5 18.9596 27.5 18.5C27.5 18.0404 27.4095 17.5852 27.2336 17.1606C27.0577 16.736 26.7999 16.3501 26.4749 16.0251C26.1499 15.7001 25.764 15.4423 25.3394 15.2664C24.9148 15.0905 24.4596 15 24 15C23.0717 15 22.1815 15.3687 21.5251 16.0251C20.8687 16.6815 20.5 17.5717 20.5 18.5C20.5 19.4283 20.8687 20.3185 21.5251 20.9749C22.1815 21.6313 23.0717 22 24 22ZM18 32V33H30V32C30 30.136 30 29.204 29.695 28.47C29.2893 27.49 28.5109 26.7112 27.531 26.305C26.796 26 25.864 26 24 26C22.136 26 21.204 26 20.47 26.305C19.9845 26.5058 19.5434 26.8003 19.1718 27.1716C18.8001 27.5429 18.5052 27.9837 18.304 28.469C18 29.204 18 30.136 18 32Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_50_126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0614 1.7561) rotate(90.0761) scale(46.2439 46.2439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357CD2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_50_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_50_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFIcon3);
export default __webpack_public_path__ + "static/media/f_icon3.1477dafe4bf85ba28a07f086a03ce9f2.svg";
export { ForwardRef as ReactComponent };